
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire164e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire164e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9wJdH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $6efa2df7948f6795$export$6503ec6e8aabbaf; }, function (v) { return $6efa2df7948f6795$export$6503ec6e8aabbaf = v; });
var $6efa2df7948f6795$export$6503ec6e8aabbaf;
var $6efa2df7948f6795$export$f7ad0328861e2f03;
"use strict";
var $6efa2df7948f6795$var$mapping = new Map();
function $6efa2df7948f6795$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$6efa2df7948f6795$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $6efa2df7948f6795$var$resolve(id) {
    var resolved = $6efa2df7948f6795$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$6efa2df7948f6795$export$6503ec6e8aabbaf = $6efa2df7948f6795$var$register;
$6efa2df7948f6795$export$f7ad0328861e2f03 = $6efa2df7948f6795$var$resolve;

});

var $1a41c580bc5f04e1$exports = {};

(parcelRequire("9wJdH")).register(new URL("", import.meta.url).toString(), JSON.parse('["gpsOK","index.0ee9e086.js","iiJ53","foodFireLogo.adc19524.png","f2uyb","offline.c7b5995e.png","lTglY","burgerImage.cadf9cb9.png","8rK2e","errorImage.1a72a7f5.jpg","6yiXo","contactUs.6d5a1f67.png"]'));


//# sourceMappingURL=index.runtime.936a5889.js.map
